import {_import_} from './_import.js';
const url = 'result'; // 模块文件夹路径
const result = _import_(url + '/index');

export default [
  {
    path: '/result',
    name: 'result',
    meta: {
      title: {title: '测评结果', color: '#30c49d'},
      needLogin: true
    },
    component: result
  }
];



// WEBPACK FOOTER //
// ./src/router/result.js